"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.toBuffer = exports.toArrayBuffer = exports.splitAddFromCkSum = exports.validateAddress = exports.getAddressRaw = void 0;
var base32_decode_1 = __importDefault(require("base32-decode"));
var blakejs_1 = require("blakejs");
var leb128_1 = __importDefault(require("leb128"));
var logs_1 = require("@ledgerhq/logs");
// Constants
var BASE_64_VARIANT_TYPE = "RFC3548";
var SECP256K1_ACTOR_LEN = 20;
var ID_MAX_LEN = 19;
var BLS_MAX_LEN = 48;
var validPrefixs = {
    f: "mainnet",
    t: "testnet"
};
var validProtocols = {
    "0": "ID",
    "1": "SECP256K1",
    "2": "Actor",
    "3": "BLS"
};
var getAddressRaw = function (address) {
    var result = (0, exports.validateAddress)(address);
    if (result.isValid) {
        var _a = result.data, address_1 = _a.address, protocol = _a.protocol;
        return Buffer.concat([
            Buffer.from("0".concat(protocol.toString()), "hex"),
            address_1,
        ]);
    }
    throw new Error("The address is not valid");
};
exports.getAddressRaw = getAddressRaw;
var validateAddress = function (input) {
    var _a;
    var _b = __read(input, 2), prefix = _b[0], protocol = _b[1];
    if (!validPrefixs[prefix])
        return { isValid: false };
    if (!validProtocols[protocol])
        return { isValid: false };
    var newCksum, rcvCksum, addr, context;
    var protocolBuf = Buffer.from("0".concat(protocol.toString()), "hex");
    var addrAndCksum = input.substr(2).toUpperCase();
    switch (protocol) {
        case "0":
            (0, logs_1.log)("debug", "String Address: ".concat(input, " --> Network:").concat(prefix, " - Protocol:").concat(protocol, " - PkHash:").concat(addrAndCksum.toLowerCase()));
            if (addrAndCksum.length > ID_MAX_LEN)
                return { isValid: false };
            addr = leb128_1["default"].unsigned.encode(addrAndCksum);
            break;
        case "1":
        case "2":
        case "3":
            _a = __read((0, exports.splitAddFromCkSum)((0, exports.toBuffer)((0, base32_decode_1["default"])(addrAndCksum, BASE_64_VARIANT_TYPE))), 2), addr = _a[0], rcvCksum = _a[1];
            if ((protocol === "1" || protocol === "2") &&
                addr.length > SECP256K1_ACTOR_LEN)
                return { isValid: false };
            if (protocol === "3" && addr.length > BLS_MAX_LEN)
                return { isValid: false };
            context = (0, blakejs_1.blake2bInit)(4);
            (0, blakejs_1.blake2bUpdate)(context, Buffer.concat([protocolBuf, addr]));
            newCksum = Buffer.from((0, blakejs_1.blake2bFinal)(context));
            (0, logs_1.log)("debug", "String Address: ".concat(input, " --> Network:").concat(prefix, " - Protocol:").concat(protocol, " - PkHash:").concat(addr.toString("hex"), " - CkSum: ").concat(rcvCksum.toString("hex")));
            if (rcvCksum.toString("hex") !== newCksum.toString("hex"))
                return { isValid: false };
            break;
        default:
            return { isValid: false };
    }
    return {
        isValid: true,
        data: {
            network: prefix,
            protocol: parseInt(protocol),
            address: addr
        }
    };
};
exports.validateAddress = validateAddress;
var splitAddFromCkSum = function (addAndCkSum) {
    var cksum = addAndCkSum.slice(-4);
    var add = addAndCkSum.slice(0, addAndCkSum.byteLength - 4);
    return [(0, exports.toBuffer)(add), (0, exports.toBuffer)(cksum)];
};
exports.splitAddFromCkSum = splitAddFromCkSum;
var toArrayBuffer = function (buf) {
    var ab = new ArrayBuffer(buf.length);
    var view = new Uint8Array(ab);
    for (var i = 0; i < buf.length; ++i) {
        view[i] = buf[i];
    }
    return ab;
};
exports.toArrayBuffer = toArrayBuffer;
var toBuffer = function (ab) {
    var buf = Buffer.alloc(ab.byteLength);
    var view = new Uint8Array(ab);
    for (var i = 0; i < buf.length; ++i) {
        buf[i] = view[i];
    }
    return buf;
};
exports.toBuffer = toBuffer;
//# sourceMappingURL=addresses.js.map